import React from "react"
import { Button, Popconfirm, Space, Form, Input } from "antd"
import {
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons"
import PersianDatePickerRange from "components/Common/PersianDatePickerRange"
import { getCurrentUser } from "helpers/service_helper"

export const columnsGrid = props => {
  const currentUser = getCurrentUser()
  const role = currentUser ? currentUser.role : null
  const isEngineer = Array.isArray(role) ? role.includes("Engineer") : role === "Engineer"

  return [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      hidden: true,
    },
    // hide engName column when current user is Engineer
    !isEngineer && {
      title: "نام",
      dataIndex: "engName",
      key: "engName",
      width: "15rem",
    },
    {
      title: "تاریخ",
      key: "Date",
      width: "15rem",
      render: record => {
        return props.isEditing(record) ? (
          <Form.Item style={{ margin: 0 }} shouldUpdate>
            {() => {
              return (
                <>
                  {/* Hidden form fields so validateFields() includes the date values */}
                  <Form.Item name="solarFromDate" style={{ display: "none", margin: 0 }}>
                    <Input />
                  </Form.Item>
                  <Form.Item name="solarToDate" style={{ display: "none", margin: 0 }}>
                    <Input />
                  </Form.Item>
                  <PersianDatePickerRange
                    key={record.id}
                    defaultFrom={record.julianFromDate}
                    defaultTo={record.julianToDate}
                    labelFrom={props.t("fromDate")}
                    labelTo={props.t("toDate")}
                    setRange={r => {
                      // update both form fields so they are returned by validateFields()
                      props.editForm.setFieldsValue({
                        solarFromDate: r.from ? r.from.persian : "",
                        solarToDate: r.to ? r.to.persian : "",
                      })
                    }}
                  />
                </>
              )
            }}
          </Form.Item>
        ) : (
          <span>
            {record.solarFromDate} - {record.solarToDate}
          </span>
        )
      },
    },
    {
      title: "شرح",
      key: "inactiveDes",
      width: 300,
      render: record => {
        return props.isEditing(record) ? (
          <Form.Item name="inactiveDes" style={{ margin: 0 }}>
            <Input.TextArea
              autoSize={{ minRows: 2, maxRows: 6 }}
            />
          </Form.Item>
        ) : (
          record.inactiveDes
        )
      },
    },
    {
      title: "عملیات",
      key: "actions",
      width: 200,
      render: record => (
        <Space>
          {props.isEditing(record) ? (
            <>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => props.save && props.save(record.id)}
              >
                ذخیره
              </Button>
              <Button
                icon={<CloseOutlined />}
                onClick={() => props.cancel && props.cancel()}
              >
                لغو
              </Button>
            </>
          ) : (
            <>
              <Button
                icon={<EditOutlined />}
                onClick={() => props.onEdit && props.onEdit(record)}
              >
                ویرایش
              </Button>
              <Popconfirm
                title="آیا مطمئن هستید؟"
                onConfirm={() => props.onDelete && props.onDelete(record.id)}
                okText="بله"
                cancelText="خیر"
              >
                <Button danger icon={<DeleteOutlined />}>
                  حذف
                </Button>
              </Popconfirm>
            </>
          )}
        </Space>
      ),
    },
  ].filter(Boolean)
}
